import axios from 'axios'

import { apiUrl } from '@/api/base.js'

export default {
    get_eval_state(args){
        return axios.post(`${apiUrl}v2/get_eval_state/`, {params: args})
    },
    get_position_info (args) {
        return axios.get(`${apiUrl}v2/get_position_info/`, { params: args })
    },
    get_position_target_info (args) {
        return axios.get(`${apiUrl}v2/get_position_target_info/`, { params: args })
    },
    post_position_info (args) {
        return axios.post(`${apiUrl}v2/post_position_info/`, { params: args })
    },
    post_position_target_info (args) {
        return axios.post(`${apiUrl}v2/post_position_target_info/`, { params: args })
    },
    get_position_rate_info (args) {
        return axios.get(`${apiUrl}v2/get_position_rate_info/`, { params: args })
    },
    get_position_rate_info_target (args) {
        return axios.get(`${apiUrl}v2/get_position_rate_info_target/`, { params: args })
    },
    // post_skill_submit_file(args){
    //     return axios.post(`${apiUrl}v2/post_skill_submit_file/`, {params: args}, { 'content-type': 'multipart/form-data' })
    // }
}